export const address = {
    addressForm: {
        userAddressAddSuccess: 'Eine Adresse wurde gerade hinzugefügt.',
        userAddressUpdateSuccess: 'Sie haben eine Adresse erfolgreich bearbeitet.',
        userAddressDeleteSuccess: 'Eine Adresse wurde gerade gelöscht.'
    }
};
